$(function() {
    var modal = function() {
        var self = this;
        var templates = {};
        var reload = false;

        function getTemplate (name, callback) {
            if (!templates.hasOwnProperty(name)) {
                templates[name] = $('#' + name).html();
            }

            callback(templates[name]);
        }

        self.show = function (name, data, reloadPage = false) {
            reload = reloadPage;
            getTemplate(name, function (template) {
                var html = Mustache.render(template, data);
                $('body').append(html);
                $('#' + name + '-modal').addClass('is-active');
            });
        };

        self.hide = function ($element) {
            $element.remove();
            if (reload === true) {
                document.location.reload();
            }
        };
    };

    window.Modal = new modal();

    $(document).on('click', '*[aria-label="close"]', function() {
        window.Modal.hide($(this).parents('.modal'));
    });

    $(document).on('click', '*[aria-label="show"]', function() {
        var $element = $(this);
        window.Modal.show($element.attr('data-modal'));
    });
    
});